// Layout.tsx
import FooterComponent from "../Footer/Footer";
import "./Layout.css"
import React from "react";
import Header from "../Header/Header";
import { Box } from "@mui/material";

const Layout = ({ children }: any) => {
  return (
    <main className="main" >
      <Header></Header>
      <Box className="mainContent" >{children}</Box>
      <FooterComponent />
    </main>
  );
};

export default Layout;
